// @ts-nocheck
import { mat3 } from "gl-matrix";
import { s } from "../../shared/globalState/settings";
import { Point } from "../Point";
import { Circle } from "../shapes/Circle";
import { Line } from "../shapes/Line";
import { transformPointByMatrix3 } from "../../shared/common";
import { ObjectTypes } from "../../shared/enums";



/**
 * Класс, который представляет собой точку присоединения блока или фасонного элемента
 */
export class ConnectionPoint{

    public point: Point;
    public color: number[];
    public radius: number;
    public thickness: number;
    public type: string;
    public isDisplayed: boolean;

    constructor(x, y) {
        this.point = new Point(x, y);
        this.color = s.connectionPointColor;;
        this.radius = s.connectionPointRadius;
        this.color = s.connectionPointColor;
        this.thickness = s.connectionPointThickness;

        this.type = ObjectTypes.cpoint;
        this.isDisplayed = true;
    }

    getVertices() {
        var center = this.point;
        var circle = new Circle(center, this.radius, this.color, this.thickness);
        circle.setSelectBoundary();
        var b = circle.getBoundary(circle.radius, circle.radius);
        var p1 = b.p1;
        var p2 = b.p2;
        var p3 = b.p3;
        var p4 = b.p4;

        var start1 = p1;
        var end1 = p3;
        var start2 = p2;
        var end2 = p4;

        var line1 = new Line(start1, end1, this.color, this.thickness);
        var line2 = new Line(start2, end2, this.color, this.thickness);

        var shapes = [circle, line1, line2];
        var arr = shapes.reduce((acc, a) => acc.concat(a.getVertices()), []);
        
        var typedArray = concat(arr);
        
        
        return typedArray;

    
    }

    zoom(zl) {
        const zoom_mat = mat3.fromScaling(mat3.create(), new Float32Array([zl, zl, 1]));
        // Preserve point identity: mutate coordinates instead of replacing instance
        const newPoint = transformPointByMatrix3(zoom_mat, this.point);
        this.point.x = newPoint.x;
        this.point.y = newPoint.y;
    }

    pan(tx, ty) {
        const pan_mat = mat3.fromTranslation(mat3.create(), new Float32Array([tx, ty, 0]));
        mat3.transpose(pan_mat, pan_mat);
        // Preserve point identity: mutate coordinates instead of replacing instance
        const newPoint = transformPointByMatrix3(pan_mat, this.point);
        this.point.x = newPoint.x;
        this.point.y = newPoint.y;
    }

    clone() {
        var cp = new ConnectionPoint(this.point.x, this.point.y);
        cp.isDisplayed = this.isDisplayed;
        return cp;
    }

    isConnected(segment) {
        if(!segment) return false;

        var segStart = segment.start.clone();
        var segEnd = segment.end.clone();

        if(segStart.equals(this.point) || segEnd.equals(this.point)) return true;
        return false;
    }


}

function concat(arrays) {
    // sum of individual array lengths
    let totalLength = arrays.reduce((acc, value) => acc + value.length, 0);

    if (!arrays.length) return null;

    let result = new Float32Array(totalLength);

    // for each array - copy it over result
    // next array is copied right after the previous one
    let length = 0;
    for (let array of arrays) {
        result.set(array, length);
        length += array.length;
    }

    return result;
}